module.exports = __webpack_public_path__ + "img/benefit-05-iot-3.03a6e6b9.png";